import { IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { SimpleTable } from "../../../../components/mui/table";
import { ENUM_CURRENCY, RENDERER_TYPES } from "../../../../enums";
import {
  DATE_FORMATS,
  formatDate,
} from "../../../../services/date-and-time.utils";
import { numberFormat } from "../../../../services/utils";

function ClientCampaignListTable({
  list,
  columns,
  handlePageFilters,
  appliedFilters,
  onEditClick,
}) {
  const { selectedPage, selectedPageSize } = appliedFilters;

  const handleTDRenderer = (row, column) => {
    switch (column.rendererType) {
      case RENDERER_TYPES.FULL_DATE_FROM:
        return formatDate(row.date, DATE_FORMATS.fullDateWithTime);
      case RENDERER_TYPES.AMOUNT:
        return `${numberFormat(row[column.field], ENUM_CURRENCY.USD)}`;
      case RENDERER_TYPES.NUMBER:
        return numberFormat(row[column.field]);
      case RENDERER_TYPES.ACTION:
        return (
          <IconButton size="small" onClick={() => onEditClick(row)}>
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        );
      default:
        return row[column.field] || "-";
    }
  };
  return (
    <SimpleTable
      tdRenderer={handleTDRenderer}
      rows={list?.data}
      columns={columns}
      fetching={list?.loading}
      total={list?.total}
      onPageSettingsChange={handlePageFilters}
      selectedPage={selectedPage}
      selectedPageSize={selectedPageSize}
      showPagination={false}
    />
  );
}

export { ClientCampaignListTable };
